import WebhookIcon from '@mui/icons-material/Webhook';

const fintech = {
  id: 'fintech-integration',
  title: 'Fintech Integration',
  type: 'group',
  role: 'DMP_PRODUCT_MGR',
  children: [
    {
      id: 'cashfree-webhook',
      title: 'Cashfree Webhook',
      type: 'item',
      url: '/',
      bottomMenu: 'CASHFREE-WEBHOOK',
      icon: WebhookIcon
    },
    {
      id: 'cashfree-apis',
      title: 'Cashfree API(s)',
      type: 'item',
      url: '/',
      bottomMenu: 'CASHFREE-APIS',
      icon: WebhookIcon
    },
    {
      id: 'razorpay-webhook',
      title: 'Razorpay Webhook',
      type: 'item',
      url: '/',
      bottomMenu: 'WEBHOOK',
      icon: WebhookIcon
    },
    {
      id: 'razorpay-payments',
      title: 'Razorpay Payment(s)',
      type: 'item',
      url: '/',
      bottomMenu: 'RAZORPAY',
      icon: WebhookIcon
    }
  ]
};

export default fintech;
